<template>
  <div class="evaluation-criterion">
    <div class="top-row">
      <el-button
        style="float: left"
        type="primary"
        size="medium"
        icon="el-icon-refresh"
        @click="handleReset"
        >重置为系统默认</el-button
      >
      <div class="btns">
        <el-button
          type="danger"
          size="medium"
          icon="el-icon-delete"
          :disabled="selectedIds.length == 0"
          @click="handleRemove()"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          @click="show = true"
          >新增</el-button
        >
      </div>
    </div>

    <el-table
      class="grade-item-list"
      :data="list"
      ref="dragTable"
      row-key="itemId"
      @selection-change="handleSelectionChange"
      :span-method="objectSpanMethod"
      border
    >
      <el-table-column align="center" type="selection" width="55" />
      <el-table-column label="评价项目" prop="type" align="center" width="150">
      </el-table-column>
      <el-table-column label="评价分类" prop="question">
        <template slot-scope="{ row }">
          <div>
            <el-tooltip
              class="item"
              effect="dark"
              content="拖拽跳转顺序"
              placement="top-start"
            >
              <div class="draggable"></div> </el-tooltip
            >{{ row.question }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="分值" prop="score" align="center" width="80">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="text"
            @click="
              show = true;
              itemId = row.itemId;
              form = { ...row };
            "
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="text"
            style="color: #f56c6c"
            @click="handleRemove(row.itemId)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-drawer
      :title="(itemId ? '编辑' : '新增') + '评分项目'"
      :show-close="false"
      :wrapperClosable="false"
      :visible.sync="show"
      direction="rtl"
      ref="drawer"
      class="drawer"
    >
      <div class="drawer__content">
        <el-form
          ref="form"
          label-width="80px"
          :model="form"
          :rules="rules"
          size="small"
        >
          <el-form-item label="评分项目" prop="type">
            <el-autocomplete
              v-model="form.type"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入评分项目"
              @select="handleSelect"
              style="width: 100%"
            >
              <template slot-scope="{ item }">
                <div class="name">{{ item }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="评价分类" prop="question">
            <el-input
              v-model="form.question"
              type="textarea"
              placeholder="请输入评价分类"
            />
          </el-form-item>
          <el-form-item label="满分分值" prop="score">
            <el-input-number v-model="form.score" :precision="2" />
          </el-form-item>
        </el-form>
        <div class="drawer__footer">
          <el-button size="small" @click="show = false">取 消</el-button>
          <el-button type="primary" size="small" @click="handleSubmit"
            >确 定</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  resetList,
  itemList,
  addItem,
  editItem,
  delItem,
  sort,
  itemTypeList,
} from "@/api/projectPractice/common";
import Sortable from "sortablejs";
import merge from "webpack-merge";
export default {
  props: {
    category: String,
  },
  data() {
    return {
      list: [],
      selectedIds: [],
      idArr: [],
      idPos: 0,
      show: false,
      itemId: null,
      form: {},
      rules: {
        type: { required: true, message: "请输入评分项目", trigger: "blur" },
        question: {
          required: true,
          message: "请填写评分分类",
          trigger: "blur",
        },
        score: { required: true, message: "请填写满分分值", trigger: "blur" },
      },
    };
  },
  created() {
    this.getList();
    if (!JSON.parse(this.$route.query.isInit)) {
      this.setFn();
      this.$router.replace({
        query: merge(this.$route.query, { isInit: "true" }),
      });
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.form = this.$options.data().form;
        this.itemId = null;
      }
    },
  },
  methods: {
    // 项目列表
    getList() {
      this.$loading.show();
      itemList({ category: this.category, classId: this.$route.query.id }).then(
        (res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.list = res.data;
            this.formatSpan();
            this.$nextTick(() => {
              this.setSort();
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    setSort() {
      const vm = this;
      const el = this.$refs.dragTable.$el.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];

      this.sortable = Sortable.create(el, {
        handle: ".draggable",
        onEnd: function ({ oldIndex, newIndex }) {
          const list = [...vm.list];
          // list[newIndex] = list.splice(oldIndex, 1, list[newIndex])[0];
          list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
          vm.list = list;

          const ids = list.map((item) => item.itemId);

          sort({ category: vm.category, ids }).then((res) => {
            vm.formatSpan();
          });
        },
      });
    },
    formatSpan() {
      this.idArr = [];
      this.idPos = 0;
      this.list.forEach((item, i) => {
        if (i == 0) {
          // 第一行显示
          this.idArr.push(1);
          this.idPos = 0;
        } else {
          if (this.list[i].type == this.list[i - 1].type) {
            // 相同则合并行数自加
            this.idArr[this.idPos] += 1;
            // 下一行不显示
            this.idArr.push(0);
          } else {
            // 不同则显示
            this.idArr.push(1);
            this.idPos = i;
          }
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const _row = this.idArr[rowIndex];
        // 判断当前的 列是否需要显示
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.itemId);
    },
    // 删除
    handleRemove(itemId) {
      this.$msgbox({
        title: "提示",
        message: "您确定要删除该数据？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            delItem(this.category, itemId || this.selectedIds)
              .then(() => {
                this.$message.success("删除成功");
                this.getList();
              })
              .finally(() => {
                done();
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      });
    },
    async querySearchAsync(queryString, cb) {
      let res = await itemTypeList({
        category: this.category,
        classId: this.$route.query.id,
      });
      let restaurants = res.data;
      let results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        return state.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect(item) {
      this.form.type = item;
    },
    // 提交
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.classId = this.$route.query.id;
          this.form.category = this.category;
          this.$loading.show();
          (this.itemId ? editItem : addItem)(this.form).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success(this.itemId ? "修改成功" : "添加成功");
              this.show = false;
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置
    handleReset() {
      this.$confirm(`确定要重置为系统默认吗?`, {
        type: "warning",
      })
        .then(() => {
          this.setFn();
        })
        .catch(() => {});
    },
    setFn() {
      this.$loading.show();
      resetList(this.category, this.$route.query.id).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.getList();
          this.$message.success("评价标准已初始化");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.evaluation-criterion {
  .top-row {
    margin-bottom: 10px;
    overflow: hidden;
    .btns {
      float: right;
    }
  }
  ::v-deep .grade-item-list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
    .draggable {
      display: inline-block;
      margin-right: 10px;
      background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDcgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMiAxQzIgMS41NTIyOCAxLjU1MjI4IDIgMSAyQzAuNDQ3NzE1IDIgMCAxLjU1MjI4IDAgMUMwIDAuNDQ3NzE1IDAuNDQ3NzE1IDAgMSAwQzEuNTUyMjggMCAyIDAuNDQ3NzE1IDIgMVpNNyAxQzcgMS41NTIyOCA2LjU1MjI4IDIgNiAyQzUuNDQ3NzIgMiA1IDEuNTUyMjggNSAxQzUgMC40NDc3MTUgNS40NDc3MiAwIDYgMEM2LjU1MjI4IDAgNyAwLjQ0NzcxNSA3IDFaTTEgN0MxLjU1MjI4IDcgMiA2LjU1MjI4IDIgNkMyIDUuNDQ3NzIgMS41NTIyOCA1IDEgNUMwLjQ0NzcxNSA1IDAgNS40NDc3MiAwIDZDMCA2LjU1MjI4IDAuNDQ3NzE1IDcgMSA3Wk03IDZDNyA2LjU1MjI4IDYuNTUyMjggNyA2IDdDNS40NDc3MiA3IDUgNi41NTIyOCA1IDZDNSA1LjQ0NzcyIDUuNDQ3NzIgNSA2IDVDNi41NTIyOCA1IDcgNS40NDc3MiA3IDZaTTEgMTJDMS41NTIyOCAxMiAyIDExLjU1MjMgMiAxMUMyIDEwLjQ0NzcgMS41NTIyOCAxMCAxIDEwQzAuNDQ3NzE1IDEwIDAgMTAuNDQ3NyAwIDExQzAgMTEuNTUyMyAwLjQ0NzcxNSAxMiAxIDEyWk03IDExQzcgMTEuNTUyMyA2LjU1MjI4IDEyIDYgMTJDNS40NDc3MiAxMiA1IDExLjU1MjMgNSAxMUM1IDEwLjQ0NzcgNS40NDc3MiAxMCA2IDEwQzYuNTUyMjggMTAgNyAxMC40NDc3IDcgMTFaIiBmaWxsPSIjNjU1N2ZhIi8+Cjwvc3ZnPgo=)
        center center / 7px 12px no-repeat;
      cursor: move;
      width: 8px;
      height: 14px;
      vertical-align: middle;
    }
  }
  ::v-deep .drawer {
    text-align: left;
    .drawer__content {
      padding: 0 10px;
      .el-textarea__inner {
        font-family: inherit;
      }
    }
    .drawer__footer {
      margin-top: 60px;
      text-align: center;
    }
  }
}
</style>